import React from 'react';
import { Home, TrendingUp, Calculator, FileText } from 'lucide-react';

const services = [
  {
    number: '01',
    title: 'Compra',
    description: 'Encontro consigo o imóvel que vá de acordo com as suas expectativas. Um critério de seleção feito de forma personalizada.',
    icon: Home,
  },
  {
    number: '02',
    title: 'Venda',
    description: 'Elaboração de um plano de marketing adequado ao seu imóvel. Saiba como!',
    icon: TrendingUp,
  },
  {
    number: '03',
    title: 'Encontro o "Preço Certo"',
    description: 'Análise comparativa de mercado. Parcerias com intermediários de crédito por forma a melhor orientá-lo no seu financiamento.',
    icon: Calculator,
  },
  {
    number: '04',
    title: 'Burocracias',
    description: 'Garanto o apoio necessário em todo o processo de compra e venda.',
    icon: FileText,
  },
];

export const Services = () => {
  return (
    <section id="services" className="py-20 md:py-32 bg-white" data-testid="services-section">
      <div className="container mx-auto px-6 lg:px-12">
        {/* Section Header */}
        <div className="max-w-2xl mb-20">
          <span className="text-xs tracking-[0.2em] uppercase text-stone-500 font-medium" data-testid="services-label">
            Serviços
          </span>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-light text-stone-900 mt-4 leading-tight italic font-serif uppercase tracking-tight" data-testid="services-title">
            Como posso ajudar
          </h2>
        </div>

        {/* Services List - minimal grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-16 gap-y-16">
          {services.map((service, index) => {
            const Icon = service.icon;
            return (
              <div
                key={index}
                className="group border-t border-stone-200 pt-8 hover:border-stone-900 transition-colors duration-500"
                data-testid={`service-card-${index}`}
              >
                <div className="flex items-start justify-between mb-6">
                  <span className="text-2xl italic font-serif text-stone-300 group-hover:text-stone-500 transition-colors">{service.number}</span>
                  <Icon className="w-5 h-5 text-stone-400 group-hover:text-stone-900 transition-colors" strokeWidth={1.5} />
                </div>
                <h3 className="text-2xl md:text-3xl italic font-serif text-stone-900 mb-5 uppercase tracking-tight" data-testid={`service-title-${index}`}>
                  {service.title}
                </h3>
                <p className="text-stone-600 leading-relaxed font-light">
                  {service.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
